import './SearchBar.scss';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SearchBarProps {
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
}

const SearchBar: React.FC<React.PropsWithChildren<SearchBarProps>> = props => {
  const { t } = useTranslation('answers-analytics');
  const { onChange } = props;
  const [search, setSearch] = useState<string>('');
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    onChange(e);
  };
  return (
    <div className='SearchBar-container'>
      <span className='SearchBar-searchIcon' />
      <input
        className='SearchBar-input'
        onChange={e => handleOnChange(e)}
        placeholder={t('searchBar.searchPlaceholder')}
        value={search}
      />
    </div>
  );
};

export default SearchBar;
